import {
  IResponseActivity,
  IResponseAllActivity,
  IResponseSendAsset,
  IResponseVerifyAddress,
} from '../entities/activities';

// eslint-disable-next-line
export function mapTransactions(resData: any): IResponseActivity[] {
  return resData.map((res: IResponseActivity) => mapTransaction(res));
}

/**
 * 트랜잭션 맵핑
 * @param resData
 * @returns
 */
// eslint-disable-next-line
export function mapTransaction(resData: any): IResponseActivity {
  const ret: IResponseActivity = {
    txId: resData.txId,
    timeStamp: Number(resData.timestamp),
    from: resData.from,
    to: resData.to,
    amount: resData.amount,
    coinType: resData.coin,
    fee: resData.fee,
    blockNumber: resData.blockNumber,
    type: resData.type,
    status: resData.status,
    from_memo: resData.from_memo,
    to_memo: resData.to_memo,
  };

  return ret;
}

/**
 * 모든 거래내역 맵핑
 * @param resData
 * @returns
 */
// eslint-disable-next-line
export function mapAllTransactions(resData: any): IResponseAllActivity[] {
  // console.log('mapAllTransactions resData', resData);
  return resData.transactions.map((res: IResponseAllActivity) => mapAllTransaction(res));
}

/**
 * 트랜잭션 맵핑
 * @param resData
 * @returns
 */
// eslint-disable-next-line
export function mapAllTransaction(resData: any): IResponseAllActivity {
  const ret: IResponseAllActivity = {
    idx: resData.idx,
    txId: resData.txID,
    timeStamp: Number(resData.timeStamp),
    from: resData.fromAddress,
    to: resData.toAddress,
    amount: resData.amount,
    coinType: resData.transactionType,
    fee: resData.fee,
    type: resData.type,
    status: resData.success ? 'success' : 'error',
    from_memo: resData.from_Memo || '',
    to_memo: resData.to_Memo || '',
  };

  return ret;
}

/**
 * 보내는 자산 맵핑
 * @param resData
 * @returns
 */
// eslint-disable-next-line
export function mapSendAsset(resData: any): IResponseSendAsset {
  const ret: IResponseSendAsset = {
    id: resData.id,
    phone: resData.phone,
    from: resData.from,
    to: resData.to,
    amount: resData.amount,
  };

  return ret;
}

/**
 * 주소 검증 맵핑
 * @param resData
 * @returns
 */
// eslint-disable-next-line
export function mapVerifyAddress(resData: any): IResponseVerifyAddress {
  const ret: IResponseVerifyAddress = {
    result: textToBoolean(resData.result),
  };

  return ret;
}

/**
 * 문자열을 불리언으로 변환하는 함수
 *
 * @param {string} text
 * @return {*}  {boolean}
 */
function textToBoolean(text: string): boolean {
  if (text === 'isMatched') return true;
  if (text === 'isNotMatched') return false;

  return false;
}
